import { styled } from "@linaria/react";
import React from "react";
import { fonts } from "@ui";
import type { StatusDisplay } from "./utils";
import { STATUS_BACKGROUNDS } from "./utils";

interface P {
  status: StatusDisplay;
}

const StyledBanner = styled.div<{ status: StatusDisplay }>`
  background-color: ${({ status }) =>
    status ? STATUS_BACKGROUNDS[status] : STATUS_BACKGROUNDS.DEFAULT};
  font: ${fonts.body1};
  padding: 8px 36px 8px 16px;
`;

function Banner({ status, children }: P & React.PropsWithChildren) {
  return <StyledBanner status={status}>{children}</StyledBanner>;
}

export default React.memo(Banner);
